import { Component, HostListener } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../services/httpService';



declare var cabbage: any;


@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
})
export class DemoComponent {





  source;
  connector;
  public_token = "";
  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {


   

    //this.source = 'x37hcmk2';
    //this.connector = 'link_production_wj0ut69zz8t1oz0bko3aoqmu';
    //this.fetchVendor();



    this.fetchLink();

    //cabbage.initializeLink(this.source);
    //initializaConnectPayLink(this.connector);
  }





  //show() {
  //  cabbage.displayPayLink(this.source);
  //}


  connect() {
    cabbage.openLink(this.connector);
  }


  result;

  fetchLink() {



    this.httpService.post<any>('Store/create-link-token', false).subscribe(
      resp => {


        this.result = JSON.parse(resp.message);

        if (this.result.message == "success") {

          this.connector = this.result.link_token;
          cabbage.initializeLink(this.connector);

        }


        //this.loading = false;

      },
      error => {
        //this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });





  }







  @HostListener('window:message', ['$event'])
  onMessage(event) {


    //console.log(event)

    //if (event.origin == "https://cdn-sandbox.cabbagepay.com") {

      const data = JSON.parse(event.data);
      //console.log(data.message)

      if (data.message == "success") {

        this.public_token = data.public_token;
        cabbage.closeLink();
        console.log(data.public_token)

      }



      if (data.message == "terminated") {
        console.log("termination")
        cabbage.closeLink();


      }


    



    //cabbage.closeLink();



  };

}
